var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-geojson-layer", {
        ref: "geolayer",
        attrs: { geojson: _vm.geojsonData.geojson, options: _vm.geojsonOptions }
      }),
      _vm._v(" "),
      _vm._t("default", null, {
        currentItem: _vm.currentItem,
        unit: _vm.value.metric,
        min: _vm.min,
        max: _vm.max
      }),
      _vm._v(" "),
      _c("tooltip", {
        attrs: {
          visible: _vm.ttvisible,
          top: _vm.tttop,
          left: _vm.ttleft,
          title: _vm.tttitle,
          value: _vm.ttvalue
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00bb215b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00bb215b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChoroplethLayer.vue
// module id = null
// module chunks = 